const MuiToolbar = {
  styleOverrides: {
    root: {
      fontFamily: 'Fjalla One'
    }
  }
};

export default MuiToolbar;
